import React, { useEffect, useState } from "react";
import profile from "../../assets/profile.png";
import down from "../../assets/down-arrow.png";
import up from "../../assets/up-arrow.png";
import "./currentOrdersHeader.css";
import { useDispatch } from "react-redux";
import { getProfileInfo } from "../../redux/actions/orderActions";
import { useNavigate } from "react-router-dom";
import { socket } from "../../redux/config";
import { AnimatePresence, motion } from "framer-motion";
import { useAnimatedCounter } from "../utilites/useAnimationCounter";

const CurrentOrdersHeader = ({ }) => {
  const [open, setopen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(null);
  const [dashboardCounter, setDashboardCounters] = useState(null);

  useEffect(() => {
    console.log(dispatch(getProfileInfo(onSuccess, onError)));
  }, []);

  useEffect(() => {
    socket.on("distributor_order_count", (counter) => {
      console.log("Socket Data", counter);
      setDashboardCounters({
        fullyInvoicedOrder: counter?.fullyInvoicedOrder,
        partiallyInvoicedOrder: counter?.partiallyInvoicedOrder,
        pendingOrder: counter?.pendingOrder,
        totalOrder: counter?.totalOrder,
      });
    });
    return () => {
      socket.off("distributor_order_count");
    };
  }, []);

  const onSuccess = (data) => {
    console.log(data);
    setProfileData(data.data.data);
    const counter = data.data.data;
    setDashboardCounters({
      fullyInvoicedOrder: counter?.fullyInvoicedOrder,
      partiallyInvoicedOrder: counter?.partiallyInvoicedOrder,
      pendingOrder: counter?.pendingOrder,
      totalOrder: counter?.totalOrder,
    });
  };

  const onError = (err) => {
    console.log(err);
  };

  const headingVariants = {
    hidden: { opacity: 0, y: 0 },
    visible: { opacity: 1, y: 5, transition: { duration: 0.6 } },
  };
  const headingName = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
  };

  const data = [
    {
      title: "Your ID",
      content: profileData?.distributor?.distributor_id,
    },
    {
      title: "Drug license 1",
      content: profileData?.distributor?.drug_licence_number_20_a,
    },
    {
      title: "Drug license 2",
      content: profileData?.distributor?.drug_licence_number_20_b,
    },
    {
      title: "FSSAI Number",
      content: profileData?.distributor?.fssai_number,
    },
    {
      title: "GST Number",
      content: profileData?.distributor?.gst_number,
    },
    {
      title: "Mobile Number",
      content: profileData?.distributor?.mobile,
    },
    {
      title: "Alternate Mobile Number",
      content: profileData?.distributor?.alternate_mobile,
    },
    {
      title: "Email Address",
      content: profileData?.distributor?.email,
    },
  ];

  const Seconddata = [
    {
      title: "Address",
      content:
        profileData?.distributor?.address &&
        `${profileData?.distributor?.address?.address_one}, ${profileData?.distributor?.address?.address_two}, ${profileData?.distributor?.address?.address_three}`,
    },
    {
      title: "Landmark",
      content: profileData?.distributor?.address?.landmark,
    },
    {
      title: "State",
      content: profileData?.distributor?.state?.name,
    },
    {
      title: "District",
      content: profileData?.distributor?.district?.name,
    },
    {
      title: "City",
      content: profileData?.distributor?.city?.name,
    },
    {
      title: "Pincode",
      content: profileData?.distributor?.pincode,
    },
  ];

  return (
    <div className="d-xl-flex" style={{ zIndex: 'auto' }}>
      <div className="position-relative w-100">
        <div className="distributor-header-container my-4 mx-3 mx-lg-3  w-100">
          <div className="d-flex align-items-center">
            <div className="m-3 d-flex align-items-center distributor-profile-container">
              <img
                src={
                  profileData?.distributor?.logo
                    ? profileData?.distributor?.logo
                    : profile
                }
                className="icon-container"
              />
              <motion.div
                variants={headingName}
                initial="hidden"
                animate="visible"
                className="mx-3 label-container text-start"
              >
                <label className="w-100">
                  {profileData?.distributor?.distributor_id}
                </label>
                <label className="fs_18  text-capitalize">
                  {profileData?.distributor?.firm_name}
                </label>
              </motion.div>
            </div>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="w-100" style={{ maxWidth: "700px" }}>
                <div className="mx-2 d-none d-sm-flex flex-wrap gap-3 companies-container align-items-center">
                  {profileData?.distributor?.vendorDistributors?.map(
                    (items, index) => (
                      <motion.div
                        viewport={{ once: true }}
                        initial={{ opacity: 0 }}
                        animate="visible"
                        whileInView={{
                          opacity: 1,
                          transition: { delay: index * 0.2 },
                        }}
                      >
                        <img
                          src={items?.vendor?.logo}
                          className="company-icon-container"
                        />
                      </motion.div>
                    )
                  )}
                </div>
              </div>
              <div>
                <button
                  className="drop-button mx-3 py-1"
                  onClick={() => setopen(!open)}
                >
                  {open ? (
                    <img src={up} className="mx-1" />
                  ) : (
                    <img src={down} className="mx-1" />
                  )}
                </button>
              </div>
            </div>
            <AnimatePresence>
              {open && (
                <motion.div
                  className="col-11 details-drop-container"
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 10, opacity: 0 }}
                >
                  <div className="d-xxl-flex align-items-start justify-content-between p-4 mt-3">
                    <div className="col-xxl-6">
                      {data?.map((item, index) => (
                        <div
                          key={index}
                          className="d-flex justify-content-between my-1"
                        >
                          <div className="col-xxl-5 col-xl-6 col-4">
                            <label className="color_747f9e fs_14 ">
                              {item?.title}
                            </label>
                          </div>
                          <div className="col-xxl-7 col-xl-6 col-8 fs_14 text-start">
                            <label>{item?.content}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="col-xxl-5 text-capitalize">
                      {Seconddata?.map((item, index) => (
                        <div className="d-flex justify-content-between my-1">
                          <div className="col-xxl-4 col-xl-6 col-4">
                            <label className="color_747f9e fs_14 ">
                              {item?.title}
                            </label>
                          </div>
                          <div className="col-xxl-8 col-xl-6 col-8 fs_14 text-start">
                            <label>{item?.content}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex justify-content-end m-3">
                    <button
                      className="fs_14 px-4 py-2"
                      style={{
                        backgroundColor: "#7065E4",
                        border: "none",
                        color: "#fff",
                        textTransform: "uppercase",
                        borderRadius: "5px",
                      }}
                      onClick={() => navigate("/distributor-details-edit")}
                    >
                      Edit
                    </button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
      <div className="ms-xl-2 ms-4 me-4 d-flex  flex-column justify-content-sm-start info-box-spacing justify-content-center">
        <div className=" my-xl-4 d-sm-flex justify-content-around">
          <div className="info_box mx-1 text-center">
            <div className="mt-1 d-flex flex-column py-2">
              <span className="fw_500 fs_24 fs_md_20 my-1">
                {useAnimatedCounter(dashboardCounter?.pendingOrder, 1000)}
              </span>
              <span className="fw_400 fs_12 text-center color_747f9e px-2">
                Pending Orders
              </span>
            </div>
          </div>
          <div className="info_box mx-1 text-center">
            <div className="mt-1 d-flex flex-column py-2">
              <span className="fw_500 fs_24 fs_md_20 my-1">
                {useAnimatedCounter(dashboardCounter?.fullyInvoicedOrder, 1000)}
              </span>
              <span className="fw_400 fs_12 text-center color_747f9e px-3">
                Fully Invoiced
              </span>
            </div>
          </div>
          <div className="info_box mx-1 text-center">
            <div className="mt-1 d-flex flex-column py-2">
              <span className="fw_500 fs_24 fs_md_20 my-1">
                {useAnimatedCounter(
                  dashboardCounter?.partiallyInvoicedOrder,
                  1000
                )}
              </span>
              <span className="fw_400 fs_12 text-center color_747f9e px-2">
                Partialy Invoiced
              </span>
            </div>
          </div>
          <div className="info_box mx-1 text-center">
            <div className="mt-1 d-flex flex-column py-2">
              <span className="fw_500 fs_24 fs_md_20 my-1">
                {useAnimatedCounter(dashboardCounter?.totalOrder, 1000)}
              </span>
              <span className="fw_400 fs_12 text-center color_747f9e px-3">
                Total Orders
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentOrdersHeader;
